// JOBE-0106: DepartmentLane — Department + scope lane on the header
// card. Reads `relations.inDepartment[0]` from the project payload,
// the `contains` summary from `counts` (rollups), and renders the
// static `graph` posture + `on delete` rule text per the wireframe
// (these are project-level defaults today, not per-project stored
// fields — captured in the spec).

import React from 'react';

function urnTail(urn) {
  if (!urn || typeof urn !== 'string') return '';
  return urn.split(':').pop() || urn;
}

export function DepartmentLane({ project, counts }) {
  const department =
    (project?.relations?.inDepartment && project.relations.inDepartment[0]) || null;
  const tasks = counts?.tasks ?? 0;
  const documents = counts?.documents ?? 0;
  const entities = counts?.entities_by_kind
    ? Object.values(counts.entities_by_kind).reduce((a, b) => a + b, 0)
    : 0;

  return (
    <div className="project-dept-lane">
      <h3 className="lane-title">Department &amp; scope</h3>
      <div className="lane-row">
        <span className="lane-row-label">Department</span>
        {department ? (
          <span className="dept-chip" title={department}>{urnTail(department)}</span>
        ) : (
          <span className="muted">—</span>
        )}
      </div>
      <div className="lane-row">
        <span className="lane-row-label">Contains</span>
        <span className="dept-contains">
          {tasks} tasks · {documents} documents · {entities} entities
        </span>
      </div>
      <div className="lane-row">
        <span className="lane-row-label">Graph</span>
        <span className="dept-graph mono">public</span>
      </div>
      <div className="lane-row">
        <span className="lane-row-label">On delete</span>
        <span className="dept-ondelete mono">archive cascades · hard delete blocked</span>
      </div>
    </div>
  );
}
